import ModelTypeConstants from 'constants/ModelTypeConstants';
import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';
import APIUtil from 'util/APIUtil';

export const SamplesRoutes: RouteBundle = {
  domain: 'samples',
  routes: [
    {urlPattern: 'samples/containers/:containerId', handler: containerEditor, legacy: true},
    {urlPattern: 'samples/boxes/:boxId', handler: boxEditor, legacy: true},
    {urlPattern: 'samples/plates/:plateId', handler: plateEditor, legacy: true},
    {urlPattern: 'samples/locations/:locationId', handler: locationExpandedSearch, legacy: true},
    {urlPattern: 'samples/locations/:locationId/edit', handler: locationEditor},
  ],
};

/*
 * This following 4 handlers support two formats for sample URLs:
 * - Legacy:  /samples/plates/7sMgJ2Ug
 * - Current: /samples/plates/plt_7sMgJ2Ug
 *
 * While the backend already redirects the legacy-style URL to the current-style URL,
 * there are cases where the front-end may trigger single-page-app routing to a
 * legacy URL (e.g. when such a URL is stored within notebook contents). These URLs
 * may be stored indefinitely and so this route needs to be maintained indefinitely.
 */
function containerEditor(containerId: string): void {
  EditorRoutes.containerEditor(APIUtil.withPrefixIfMissing(containerId, ModelTypeConstants.CONTAINER));
}

function boxEditor(boxId: string): void {
  EditorRoutes.boxEditor(APIUtil.withPrefixIfMissing(boxId, ModelTypeConstants.BOX));
}

function plateEditor(plateId: string): void {
  EditorRoutes.plateEditor(APIUtil.withPrefixIfMissing(plateId, ModelTypeConstants.PLATE));
}

function locationExpandedSearch(locationId: string): void {
  EditorRoutes.locationExpandedSearch(APIUtil.withPrefixIfMissing(locationId, ModelTypeConstants.LOCATION));
}

function locationEditor(locationId: string): void {
  EditorRoutes.locationEditor(APIUtil.withPrefixIfMissing(locationId, ModelTypeConstants.LOCATION));
}
